import { makeUseFetchOne } from '@elentari/core/hooks/makeUseFetchOne'
import { LocalDetail } from '../types'
import { locaisRepository } from './locaisRepository'

export const useLocal = makeUseFetchOne<LocalDetail, string>({
  fetch: locaisRepository.fetchOne
})
